<script lang="ts">
    import { sendUIInteractionAnalyticsEvent } from "@app/services/analytics/analytics-send-event";
    import AddTranslationForm from "./AddTranslationForm.svelte";

    function onClose(event: Event, id: string) {
        const activator = document.querySelector<HTMLElement>(`#${id}`);
        if (activator) {
            toggleAddTranslationForm(event, activator);
        }
    }

    function toggleAddTranslationForm(event: Event, activator: HTMLElement) {
        event.preventDefault();
        let isOpen = activator.dataset["open"] === "true" || false;
        activator.dataset["open"] = `${!isOpen}`;

        let id = activator.id;
        if (!id) {
            id = "addTranslationForm_" + Math.round(Math.random() * (1 << 30));
            activator.setAttribute("id", id);
        }
        if (!(activator as any).addTranslationForm) {
            let target: HTMLElement | null = null;
            if (activator.dataset["formContainer"]) {
                target = document.querySelector(
                    activator.dataset["formContainer"]
                );
            }

            if (target === null) {
                target = document.createElement("div");
                const targetParent = activator.parentElement;
                if (!targetParent) {
                    console.error("Can't find activator parent, HTML is invalid");
                    return;
                }
                targetParent.insertBefore(target, activator.nextSibling);
            }
            let phrase = (window as any).glosbe.phrase;
            let translationPhrase = activator.dataset["targetPhrase"];

            (activator as any).addTranslationForm = new AddTranslationForm({
                target: target,
                props: {
                    onClose,
                    translatedPhrase: phrase,
                    translationPhrase,
                    id,
                },
            });
        }

        setTimeout(() => {
            const open = activator.dataset["open"] === "true" || false;
            sendUIInteractionAnalyticsEvent({
                action: "expand-add-translation",
                label: open ? "open" : "close",
            });
            (activator as any).addTranslationForm.$set({ open });
        });
    }

    function isElementAddFormActivator(element: HTMLElement) {
        if (element) {
            return element.matches(".add-translation-inline");
        }
        return false;
    }

    document.addEventListener("click", (clickEvent: Event) => {
        const targetElement = clickEvent.target;

        let element: HTMLElement | null = targetElement as HTMLElement;
        let matched = isElementAddFormActivator(element);

        while (element != null && !matched) {
            element = element.parentElement;
            if (element !== null) {
                matched = isElementAddFormActivator(element);
            }
        }
        if (matched && element !== null) {
            toggleAddTranslationForm(clickEvent, element);
        }
    });
</script>
